import CircularProgress from '@/components/CircularProgress';
import CheckCircle from '@/components/Icons/CheckCircle';
import WarningCircle from '@/components/Icons/WarningCircle';
import ProgressIndicator from '@/components/ProgressIndicator';
import s from './SectionNavigation.module.scss';

type Props = {
  isLoading: boolean;
  progress: number | null;
  hasError: boolean;
};

const SectionProgressIcon: React.FC<Props> = ({ hasError, isLoading, progress }) => {
  if (isLoading) {
    return <ProgressIndicator size={14} />;
  }

  if (hasError) {
    return <WarningCircle className={s['error-indicator']} size={16} />;
  }

  if (progress === 100) {
    return <CheckCircle weight="fill" color="var(--color-success)" size={14} />;
  }

  if (typeof progress === 'number') {
    return <CircularProgress size={14} progress={progress} />;
  }

  return null;
};

export default SectionProgressIcon;